export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('visible', (el, binding) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: Type el properly
    el.style.visibility = binding.value ? 'visible' : 'hidden'
  })
})
